import React from 'react';
import styled, { css } from 'styled-components';
import { TABLET_TEXT_WIDTH, LAPTOP_TEXT_WIDTH, FULLHD_TEXT_WIDTH, DULL_GREY } from '@constants/params';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Points, marginLevel } from '@styles';

export const Quote = ({ html = '', children }) => (
  <>{html ? <View dangerouslySetInnerHTML={{ __html: html }} /> : <View>{children}</View>}</>
);

export const styles = {
  container: css`
    width: 100%;
    color: ${DULL_GREY};
    border-top: 1px solid ${Colors.main_beige};
    border-bottom: 1px solid ${Colors.main_beige};
    padding: 16px;
    ${marginLevel('both', 'showcase_block')};
    margin-left: auto;
    margin-right: auto;

    .author-wrapper {
      display: flex;
      gap: 10px;
      margin-bottom: 12px;
    }

    .author-wrapper span {
      flex-shrink: 0;
    }

    .author-caption-wrapper {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      align-items: start;
      gap: 2px;
    }

    .author-portrait {
      border-radius: 50%;
      width: 38px;
      height: 38px;
    }

    .author-name {
      color: ${Colors.main_dark};
      font-size: 18px;
      line-height: 1.2;
      font-weight: 400;
    }

    .author-about {
      color: ${Colors.main_gray};
      font-size: 12px;
      line-height: 1.115;
    }

    .quote-text {
      font-size: 16px;
      line-height: 1.3;
      font-weight: 400;
    }

    @media ${Points.tablet_portrait} {
      width: ${TABLET_TEXT_WIDTH};
      padding: 20px 25px 25px;

      .author-wrapper {
        margin-bottom: 15px;
      }
    }

    @media ${Points.laptop} {
      width: ${LAPTOP_TEXT_WIDTH};
      padding: 25px 30px 30px;

      .author-wrapper {
        margin-bottom: 20px;
      }

      .author-portrait {
        width: 44px;
        height: 44px;
      }

      .author-name {
        font-size: 20px;
      }

      .author-about {
        font-size: 14px;
      }

      .quote-text {
        font-size: 16px;
        line-height: 1.2;
      }
    }

    @media ${Points.fullhd} {
      width: ${FULLHD_TEXT_WIDTH};
      padding: 35px 40px 40px;

      .author-portrait {
        width: 50px;
        height: 50px;
      }

      .author-name {
        font-size: 20px;
      }

      .author-about {
        font-size: 14px;
      }

      .quote-text {
        font-size: 18px;
        line-height: 1.3;
      }
    }
  `,
};

export const View = styled.div`
  ${styles.container};
`;
